import React, { Component } from 'react';
// import { render } from 'react-dom';
// import Calendar from 'react-calendar';
// import Calendar from 'entry.nostyle'
// import './CalenderSample.css';
// import './Calendar.css';
import Calendar from 'react-calendar/dist/entry.nostyle';
import TextInput from '../TextInput';
import { calendarEventSvgIcon } from '../../../pages/createEvent/page/SelectMesaType/components/svgIcons';
// import Label from '../Label';

export default class Sample extends Component {
  constructor(props) {
    super(props);
    this.calendarInput = null;
    this.handleOnChange = this.handleOnChange.bind(this);
    // this.calendarIcon
    this.dateTextBox = null;
  }

  state = {
    actualDate: '',
    date: '',
    visibility: false,
    style: true,
  }

  setDate(date) {
    this.setState({ date });
  }

  handleOnChange = (date) => {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }

    if (month < 10) {
      month = '0' + month;
    }
    this.setState({ date: dt + '/' + month + '/' + year, actualDate: date, style: false });
    if (this.props.getCalenderDate) {
      this.props.getCalenderDate({ year, month, date: dt });
    }
    if (this.props.onChangeHandler) {
      this.props.onChangeHandler(dt + '/' + month + '/' + year);
    }
    this.dateTextBox.setValue(dt + '/' + month + '/' + year);
    this.setState({ visibility: false });
  }

  clearSelectedData() {
    this.dateTextBox.setValue('');
    this.setState({ date: '', actualDate: new Date() });
  }

  onClickday = (event) => 
    {
      this.setState({ visibility: false });
    }
    

  handleClickOutside = (event) => {
    if (this.calendarInput && !this.calendarInput.contains(event.target)) {
      this.setState({ visibility: false });
    }
  };
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  openCalendar = () => {
    this.setState({ visibility: !this.state.visibility });
  }
  calendarIcon() {
    return (
      <span className="input-group-addon">
        <span id="a" className="glyphicon-calendar" onClick={() => this.setState({ visibility: !this.state.visibility })} />
      </span>
    );
  }
  setControlState(isValildState, errorMessage, errorAttributes) {
    this.dateTextBox.setControlState(isValildState, errorMessage, errorAttributes, true);
    // Note : To fix error issue we are calling tetInput setControl.
    // this.isControlStateValid = isValildState;
    if (isValildState) {
      this.dateTextBox.textControl.classList.remove('calenderError');
    } else {
      this.dateTextBox.textControl.classList.add('calenderError');
    }
  }

  parseDateString = (dateStr) => {
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`);
  }
  toggleCalendar = (e) => {
    e.stopPropagation();
    const newVisibility = !this.state.visibility;

    this.setState({ visibility: newVisibility }, () => {
      if (newVisibility) {
        document.addEventListener('mousedown', this.handleClickOutsideOnce);
      }
    });
  };

  handleClickOutsideOnce = (event) => {
    if (this.calendarInput && !this.calendarInput.contains(event.target)) {
      this.setState({ visibility: false }, () => {
        document.removeEventListener('mousedown', this.handleClickOutsideOnce);
      });
    }
  };

  render() {
    /* eslint-disable */
    const { visibility } = this.state;
    const date = this.props.activeStartDate || this.state.actualDate;
    const viewType = this.props.viewType ? this.props.viewType : 'default';
    const minDate = this.props.minDate;
    const maxDate = this.props.maxDate;
    // const now = new Date();
    return (
      <div className="Sample" ref={cal => (this.calendarInput = cal)}>
        <div className="calendar-input">
          <div className="formBlock" style={this.props.style ? this.props.style : null}>
            <TextInput
              star="*"
              doNotUpdateOnPropsChange="true"
              defaultValue={this.props.value}
              ref={calendar => this.dateTextBox = calendar}
              className={"inputMaterial newInput calendarInputWeb"}
              labelClassName={"placeHolderMaterial"}
              htmlId={this.props.textInputJSON.textHtmlId}
              name={this.props.textInputJSON.textName}
              label={this.props.textInputJSON.textPlaceholder}
              required={this.props.textInputJSON.textPlaceholder}
              disabled={this.props.disabled}
              value={this.props.value ? this.props.value : null}
              onFocus={(e) => e.target.blur()}
              onClickHandler={!this.props.disabled ? this.toggleCalendar : null}
              childElement={(<span className="calendar-wap-svg-icon" onClick={!this.props.disabled ? this.toggleCalendar : null}>
                  {calendarEventSvgIcon}
                {/* <span id="a" className="glyphicon-calendarevent-wap" dangerouslySetInnerHTML={{__html:calendarEventSvgIcon}}/> */}
              </span>)}
            ></TextInput>
          </div>
        </div>
        <div className="Sample__container">
          <main className="Sample__container__content center-block" ref={(node) => { this.calendarInput = node; }}>
            {visibility ? <Calendar
              onChange={this.handleOnChange}
              next2Label=""
              prev2Label=""
              minDate={minDate}
              maxDate={maxDate}
              locale="es-Es"
              value={this.state.actualDate === '' && typeof this.props.value === 'string' && this.props.value.trim() !== '' ? this.parseDateString(this.props.value) : this.state.actualDate || this.props.activeStartDate || new Date()}
              view={viewType}
              //onClickDay={this.onClickday}
              activeStartDate={date ? new Date(this.state.date.getFullYear, this.state.date.getMonth, this.state.date.getDate) : new Date()}
            /> : null}
          </main>
        </div>
        {/* <div className="error" ref={err => this.errorControl = err} /> */}
      </div>
    );
  }
  /* eslint-enable */
}

